import React, { useState } from 'react';
interface PricingOption {
  id: string;
  emoji: string;
  title: string;
  description: string;
  originalPrice: string;
  price: string;
  ctaText: string;
  ctaHref: string;
  isFeatured?: boolean;
  savings?: string;
}
const options: PricingOption[] = [{
  id: 'primaria',
  emoji: '📘',
  title: 'PRIMARIA',
  description: '6 tomos + 120 clases + bonos',
  originalPrice: '$53.000',
  price: '$19.990',
  ctaText: 'SÍ, QUIERO PRIMARIA →',
  ctaHref: 'https://www.profepack.com/cart/48115450446080:1'
}, {
  id: 'completo',
  emoji: '🏆',
  title: 'PACK COMPLETO',
  description: '12 tomos + 240 clases + bonos',
  originalPrice: '$35.980',
  price: '$27.990',
  ctaText: 'SÍ, QUIERO PACK COMPLETO →',
  ctaHref: 'https://www.profepack.com/cart/48097188577536:1',
  isFeatured: true,
  savings: 'AHORRÁS $7.990'
}, {
  id: 'secundaria',
  emoji: '📗',
  title: 'SECUNDARIA',
  description: '6 tomos + 120 clases + bonos',
  originalPrice: '$53.000',
  price: '$19.990',
  ctaText: 'SÍ, QUIERO SECUNDARIA →',
  ctaHref: 'https://www.profepack.com/cart/48115461456128:1'
}];
export function PricingSection() {
  const [selected, setSelected] = useState('completo');
  const selectedOption = options.find(o => o.id === selected)!;
  return <section id="pricing" className="w-full bg-[#111111] py-10 sm:py-16 px-4" data-id="element-91">
      <div className="max-w-xl mx-auto" data-id="element-92">
        {/* Header */}
        <h2 className="text-2xl sm:text-4xl font-black text-white text-center mb-1 sm:mb-2" data-id="element-93">
          Elegí tu <span className="text-[#FF6B00]" data-id="element-94">PROFEPACK:</span>
        </h2>
        <p className="text-gray-400 text-center text-xs sm:text-base mb-5 sm:mb-8" data-id="element-95">
          Todas las opciones incluyen los 6 bonos estratégicos
        </p>

        {/* Options */}
        <div className="space-y-2.5 sm:space-y-3 mb-5 sm:mb-6" data-id="element-96">
          {options.map(option => {
          const isSelected = selected === option.id;
          const isFeatured = option.isFeatured;
          return <button key={option.id} onClick={() => setSelected(option.id)} className={`w-full text-left rounded-xl sm:rounded-2xl p-3.5 sm:p-5 transition-all ${isFeatured && isSelected ? 'border-2 border-[#FF6B00] bg-[#0d0800] shadow-[0_0_30px_rgba(255,107,0,0.15)]' : isFeatured ? 'border-2 border-[#FF6B00]/50 bg-[#0d0800]' : isSelected ? 'border-2 border-[#FF6B00] bg-[#0a0a0a]' : 'border border-white/10 bg-[#0a0a0a]'}`} data-id="element-97">
                <div className="flex items-center gap-3 sm:gap-4" data-id="element-98">
                  {/* Radio */}
                  <div className={`w-[22px] h-[22px] sm:w-6 sm:h-6 rounded-full border-2 flex-shrink-0 flex items-center justify-center ${isSelected ? 'border-[#FF6B00]' : 'border-white/30'}`} data-id="element-99">
                    {isSelected && <div className="w-2.5 h-2.5 sm:w-3 sm:h-3 rounded-full bg-[#FF6B00]" data-id="element-100" />}
                  </div>

                  {/* Info */}
                  <div className="flex-1 min-w-0" data-id="element-101">
                    <div className="flex items-center gap-1.5 sm:gap-2" data-id="element-102">
                      <span className="text-base sm:text-lg" data-id="element-103">
                        {option.emoji}
                      </span>
                      <span className="text-white font-black text-base sm:text-lg" data-id="element-104">
                        {option.title}
                      </span>
                      {isFeatured && <span className="bg-[#FF6B00] text-black text-[10px] sm:text-xs font-black px-2 sm:px-2.5 py-0.5 rounded-full leading-none" data-id="element-105">
                          ⭐ TOP
                        </span>}
                    </div>
                    <div className="flex items-center gap-2 mt-0.5" data-id="element-106">
                      <p className="text-gray-400 text-[13px] sm:text-sm" data-id="element-107">
                        {option.description}
                      </p>
                      {isFeatured && option.savings && <span className="bg-[#FF6B00]/20 text-[#FF6B00] text-[10px] sm:text-xs font-bold px-2 sm:px-2.5 py-0.5 rounded-full border border-[#FF6B00]/40 whitespace-nowrap" data-id="element-108">
                          {option.savings}
                        </span>}
                    </div>
                  </div>

                  {/* Price */}
                  <div className="text-right flex-shrink-0" data-id="element-109">
                    <div className="text-gray-500 line-through text-[11px] sm:text-sm" data-id="element-110">
                      {option.originalPrice}
                    </div>
                    <div className={`font-black text-2xl sm:text-3xl ${isFeatured ? 'text-[#FF6B00]' : 'text-white'}`} data-id="element-111">
                      {option.price}
                    </div>
                  </div>
                </div>
              </button>;
        })}
        </div>

        {/* CTA Button */}
        <a href={selectedOption.ctaHref} className="btn-orange-pulse block w-full text-center bg-[#FF6B00] font-black text-lg sm:text-xl py-4 sm:py-5 rounded-xl sm:rounded-2xl hover:bg-orange-400 transition-colors text-white shadow-[0_0_30px_rgba(255,107,0,0.25)]" data-id="element-112">
          {selectedOption.ctaText}
        </a>

        {/* Trust bar */}
        <div className="flex items-center justify-center gap-2 sm:gap-4 text-[11px] sm:text-sm text-gray-400 mt-3 sm:mt-5" data-id="element-113">
          <span data-id="element-114">🔒 Pago seguro</span>
          <span data-id="element-115">⚡ Acceso en 5 min</span>
          <span data-id="element-116">🛡️ Garantía 7 días</span>
          <span data-id="element-117">💳 Mercado Pago</span>
        </div>
      </div>
    </section>;
}